import { Grid } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const StyledSpan = styled.span`
  cursor: pointer;
  color: ${colorTokens.secondary.main};
  margin-left: 5px;
`;

export const StyledGrid = styled(Grid)`
  font-weight: 200;
`;
